import { createFileRoute, Outlet, redirect, useLocation, useNavigate } from "@tanstack/react-router";
import { Layout, Menu, Drawer, theme } from "antd";
import { MonitorOutlined, SettingOutlined } from "@ant-design/icons";
import { supabase } from "@/configs/supabase/config";
import { useShell_Nav } from "@/providers/Provider_Shell";

export const Route = createFileRoute("/_protected/$organizationId/$flowId")({
  beforeLoad: async ({ params }) => {
    const { organizationId, flowId } = params;

    const sb_FromFlows_Select = await supabase
      .from("flows")
      .select("id, slug")
      .eq("slug", flowId)
      .eq("status", "active")
      .single();

    if (sb_FromFlows_Select.error || !sb_FromFlows_Select.data) {
      throw redirect({ to: "/$organizationId", params: { organizationId } });
    }

    const sb_FromOrganizationFlows_Select = await supabase
      .from("admin__rel__flows__organizations")
      .select("flow_id")
      .eq("organization_id", organizationId)
      .eq("flow_id", sb_FromFlows_Select.data.id)
      .single();

    if (sb_FromOrganizationFlows_Select.error || !sb_FromOrganizationFlows_Select.data) {
      throw redirect({ to: "/$organizationId", params: { organizationId } });
    }

    return { flowId, flowDbId: sb_FromFlows_Select.data.id };
  },
  component: FlowLayout,
});

function FlowLayout() {
  const { token } = theme.useToken();
  const { organizationId, flowId } = Route.useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const nav = useShell_Nav();

  const selectedKey = location.pathname.includes("/settings") ? "settings" : "sessions";

  const menuItems = [
    {
      key: "sessions",
      icon: <MonitorOutlined />,
      label: "Sessions",
      onClick: () => {
        navigate({ to: "/$organizationId/$flowId/sessions", params: { organizationId, flowId } });
        nav.setMobileOpen(false);
      },
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Settings",
      onClick: () => {
        navigate({ to: "/$organizationId/$flowId/settings/provider", params: { organizationId, flowId } });
        nav.setMobileOpen(false);
      },
    },
  ];

  const menu = (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems}
      style={{ borderRight: 0, paddingTop: token.paddingSM }}
    />
  );

  return (
    <Layout style={{ height: "calc(100dvh - 48px)" }}>
      {!nav.isMobile && (
        <Layout.Sider
          width={180}
          collapsible
          collapsed={nav.isCompact || nav.collapsed}
          collapsedWidth={80}
          trigger={null}
          style={{
            background: token.colorBgContainer,
            borderRight: `1px solid ${token.colorBorderSecondary}`,
            overflow: "auto",
            position: "sticky",
            top: 48,
            height: "calc(100dvh - 48px)",
          }}
        >
          {menu}
        </Layout.Sider>
      )}
      <Drawer
        placement="left"
        open={nav.isMobile && nav.mobileOpen}
        onClose={() => nav.setMobileOpen(false)}
        width={220}
        title="Navigation"
        styles={{ body: { padding: 0 } }}
      >
        {menu}
      </Drawer>
      <Layout.Content style={{ padding: nav.isMobile ? token.paddingSM : token.paddingLG, overflow: "auto" }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
